import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemSlugBroth extends Item {
    constructor() {
        super(definitions.ITEM_ID.SLUG_BROTH, texture("prop_mug_slug_broth_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}